import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "price-details" }
const _hoisted_2 = { class: "price-details__header" }
const _hoisted_3 = { class: "price-details__list" }
const _hoisted_4 = { class: "price-details__item-type" }
const _hoisted_5 = { class: "price-details__item-price" }
const _hoisted_6 = { class: "price-details__footer" }
const _hoisted_7 = { class: "price-details__price-label-container" }
const _hoisted_8 = { class: "price-details__summary" }
const _hoisted_9 = { class: "price-details__price" }
const _hoisted_10 = { class: "price-details__payments" }
const _hoisted_11 = ["src", "title", "alt"]

import type { MergedOfferItemData, TravellerPrice } from '@interfaces/offer';
import { getPaymentUrl } from '@utils/environmentUtils';
import { formatPrice, getFinalPriceWithCurrency } from '@/js/utils/priceUtils';
import { PAYMENT_TYPES } from '@global-js/constants';
import { computed } from 'vue';

interface Props {
	offerData: MergedOfferItemData;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceDetails',
  props: {
    offerData: {}
  },
  setup(__props: any) {

const props = __props;

const travellerAmount = computed((): number => props.offerData.TravellerAmount);

const offerStatus = computed((): string | undefined => props.offerData.Status);

const offerCurrency = computed((): string => props.offerData.CurrencyCode);

const offerPrice = computed((): number | null => props.offerData.Price);

const finalPrice = computed((): string => {
	const verified = {
		price: offerPrice.value,
		currency: offerCurrency.value,
	};

	const unverified = {
		price: props.offerData.unverifiedPrice,
		currency: props.offerData.unverifiedCurrency,
		travellerAmount: travellerAmount.value,
	};

	return getFinalPriceWithCurrency(offerStatus.value as string, verified, unverified);
});

const priceDifference = computed((): string => {
	if (!offerPrice.value) return '';
	const assumedPrice = props.offerData.unverifiedPrice * travellerAmount.value;
	const strippedFinalPrice = parseFloat(offerPrice.value.toString());

	if (assumedPrice > strippedFinalPrice) {
		return assumedPrice - strippedFinalPrice > 10 ? 'lower' : 'equal';
	}
	if (assumedPrice < strippedFinalPrice) {
		return strippedFinalPrice - assumedPrice > 10 ? 'higher' : 'equal';
	}
	return 'equal';
});

const priceChangeText = computed((): string => {
	if (priceDifference.value === 'lower') {
		return 'Angebot wurde günstiger';
	}
	if (priceDifference.value === 'higher') {
		return 'Preisänderung des Veranstalters';
	}
	return '';
});

const travellerPrices = computed((): TravellerPrice[] | undefined => {
	if (!props.offerData.TravellerPrice) {
		return undefined;
	}

	if (offerStatus.value === 'CheckUnable' || offerStatus.value === 'Undefined') {
		return [
			{
				Label: 'Alle Personen',
				Price: finalPrice.value,
			},
		];
	}

	return props.offerData.TravellerPrice.map((traveller: TravellerPrice) => ({
		Label: traveller.Label,
		Price: formatPrice(traveller.Price as number, props.offerData.CurrencyCode, true),
	}));
});

const paymentTypes = computed((): Record<string, string>[] => {
	const url = getPaymentUrl();
	const types = PAYMENT_TYPES;

	return props.offerData.AvailablePaymentTypes.map((payment: string) => {
		const type = types[payment];

		return {
			img: `${url}/${type.img}.png`,
			name: type.label,
		};
	});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (priceDifference.value != 'equal' && offerStatus.value === 'Available')
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["price-details__price-change", priceDifference.value === 'lower' ? 'price-details__price-change--lower' : 'price-details__price-change--higher'])
          }, _toDisplayString(priceChangeText.value), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (travellerPrices.value && travellerPrices.value.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(travellerPrices.value, (traveller, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "price-details__list-item"
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(traveller.Label), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_5, _toDisplayString(traveller.Price), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "price-details__price-label" }, " Gesamtpreis ", -1 /* HOISTED */)),
          _createElementVNode("p", _hoisted_9, _toDisplayString(finalPrice.value), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentTypes.value, (item, index) => {
            return (_openBlock(), _createElementBlock("img", {
              key: index,
              class: "price-details__payment-img",
              src: item.img,
              title: item.name,
              alt: item.name
            }, null, 8 /* PROPS */, _hoisted_11))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

})